import enviro from 'enviro';
const MICROSOFT_DRIVE_APP_IDS = {
  QA: 35132221,
  PROD: 43904875
};
export const MICROSOFT_DRIVE_APP_ID = enviro.isQa() ? MICROSOFT_DRIVE_APP_IDS.QA : MICROSOFT_DRIVE_APP_IDS.PROD;
export const APP_FEATURE_IDS = {
  MANAGE_CONNECTIONS: 'manageConnections'
};
export const MICROSOFT_DRIVE_COMPONENTS = {
  ONE_DRIVE: 'ONE_DRIVE',
  SHARE_POINT: 'SHARE_POINT'
};
export const DEFAULT_SELECTED_COMPONENT = MICROSOFT_DRIVE_COMPONENTS.SHARE_POINT;
const ONE_DRIVE_SCOPES = ['User.Read', 'Files.ReadWrite.All'];
export const SCOPES = {
  [MICROSOFT_DRIVE_COMPONENTS.ONE_DRIVE]: ONE_DRIVE_SCOPES,
  [MICROSOFT_DRIVE_COMPONENTS.SHARE_POINT]: [...ONE_DRIVE_SCOPES, 'Sites.Read.All']
};